/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { matchRoute } from './routes.jsx'
import CallClosed from './components/CallClosed.jsx'

export default function App({ path }) {
  const { Component } = matchRoute(path)
  return (
    <>
      <Component />
      <CallClosed />
    </>
  )
}
